import { render, staticRenderFns } from "./AddToBasket.vue?vue&type=template&id=64508780&scoped=true"
import script from "./AddToBasket.vue?vue&type=script&lang=js"
export * from "./AddToBasket.vue?vue&type=script&lang=js"
import style0 from "./AddToBasket.vue?vue&type=style&index=0&id=64508780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64508780",
  null
  
)

export default component.exports